import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full h-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex m-auto"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col px-4 py-5 w-full"
}
const _hoisted_4 = { class: "flex flex-col space-y-3 w-full pb-8" }
const _hoisted_5 = {
  key: 1,
  class: "p-3 bg-brand-dark-gray text-brand-light-gray rounded-lg w-full text-center"
}
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col space-y-3 w-full pb-8"
}

import {onMounted, ref, Ref} from "vue";
import {EventInterface} from "@/interfaces/EventInterface";
import ApiService from "@/services/api/apiService";
import {EventFilterIs} from "@/definitions/EventFilterIs";
import EventCard from "@/components/EventCard.vue";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {modalController, useIonRouter} from "@ionic/vue";
import FeedPostContextMenu from "@/views/feed/FeedPostContextMenu.vue";
import EventContextMenu from "@/views/events/EventContextMenu.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsMyEvents',
  emits: ['onEventTapped'],
  setup(__props, { emit: __emit }) {


const emit = __emit

const upcoming: Ref<EventInterface[]> = ref([])
const past: Ref<EventInterface[]> = ref([])

const loading = ref(true)
const observer = ref()

onMounted(async () => {
  await getData()
  loading.value = false

  observer.value = Observable.subscribe(async (response: any) => {
    if (response.event === (
        ObservableEvent.PullToRefreshMyEvents ||
        ObservableEvent.EventsScrollTop
    )) {
      await pullToRefresh(response.data)
    }
  })

})

const pullToRefresh = async (ev?: any) => {
  await getData()
  Observable.emit(ObservableEvent.PendingEventResponsesChanged)
  if (ev) ev.target.complete()
}

const getData = async () => {

  const data = await Promise.all([
    await ApiService.Events().all(EventFilterIs.MyEventsUpcoming),
    await ApiService.Events().all(EventFilterIs.MyEventsPast),
  ])

  upcoming.value = data[0]
  past.value = data[1]
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("svg", {
            class: "animate-spin h-10 w-10 m-auto text-white",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }),
            _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex text-white text-lg font-medium" }, "Upcoming", -1)),
            (upcoming.value.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(upcoming.value, (event) => {
                  return (_openBlock(), _createBlock(EventCard, {
                    onClick: ($event: any) => (emit('onEventTapped', event)),
                    layout: "list",
                    event: event,
                    key: event.id
                  }, null, 8, ["onClick", "event"]))
                }), 128))
              : _createCommentVNode("", true),
            (!upcoming.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " You don't have any upcoming events organised. "))
              : _createCommentVNode("", true)
          ]),
          (past.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex text-white text-lg font-medium" }, "Past", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(past.value, (event) => {
                  return (_openBlock(), _createBlock(EventCard, {
                    onClick: ($event: any) => (emit('onEventTapped', event)),
                    key: event.id,
                    layout: "list",
                    event: event
                  }, null, 8, ["onClick", "event"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})